import React from 'react';
import {t} from '@lingui/core/macro';

import styles from './AnswerEmail.module.scss';

interface AskEmailProps {
    className?: string;
}

const AskEmail: React.FC<AskEmailProps> = ({className}) => {

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>{t`Зачем подтверждать почту`}?</h3>
            <ol className={styles.text}>
                <li>{t`Возможность восстановить доступ к аккаунту при утрате пароля`}!</li>
                <li>{t`Защита от удаления аккаунта`}!</li>
                <li>{t`Получение писем о состоянии мониторов`}!</li>
            </ol>
            <div className={className}></div>
        </div>
    );
};

export default AskEmail;